import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { CommonUrls, redirectUrls } from 'src/constants/appPaths';

const useRedirect = () => {
  const isReactApp = useMemo(() => window.parent === window, []);
  const navigate = useNavigate();

  const getUrl = useCallback(
    <T extends keyof CommonUrls>(type: T) => {
      if (isReactApp) {
        return redirectUrls.reactUrls[type] as CommonUrls[T];
      }

      return redirectUrls.devUrls[type] as CommonUrls[T];
    },

    [isReactApp]
  );

  const redirect = useCallback(
    (url: string, isExternalUrl: boolean = false, isNewTab: boolean = true) => {
      if (isReactApp) {
        if (!isNewTab) {
          return navigate(url);
        }
        if (isExternalUrl || isNewTab) {
          return window.open(url);
        } else {
          return navigate(url);
        }
      } else {
        window.parent.postMessage({ isNewTab, parentRedirectURL: url }, '*');
      }
    },
    [isReactApp, navigate]
  );

  return {
    getUrl,
    redirect,
  };
};

export default useRedirect;
